import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-training-and-placement-cell-and-three-cell',
  templateUrl: './training-and-placement-cell-and-three-cell.component.html',
  styleUrls: ['./training-and-placement-cell-and-three-cell.component.scss']
})
export class TrainingAndPlacementCellAndThreeCellComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
